import { render } from "./PayModeDetail.vue?vue&type=template&id=52703b9c"
import script from "./PayModeDetail.vue?vue&type=script&lang=js"
export * from "./PayModeDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__